// extracted by mini-css-extract-plugin
export default {"layout":"AuthPanel_layout__gxkLC","content":"AuthPanel_content__suDbd","row":"AuthPanel_row__CZHIE","footer":"AuthPanel_footer__4+e7P"};